import { AxiosResponse } from "axios";
import { API } from "../index";

export type MyPageSummary = {
  reservation_count: number;
  ticket_count: number;
  order_count: number;
  table_order_count: number;
  coupon_count: number;
  reservation_gift_count: number;
  ticket_gift_count: number;
  voucher_gift_count: number;
  coupon_gift_count: number;
};

export const MYPAGE_SUMMARY_QUERY_KEY = ["mypage-summary"] as const;

export const mypageService = {
  getSummary: async (): Promise<AxiosResponse<MyPageSummary>> => {
    return await API.get("/api/v2/my-page/summary");
  },
};
